<script setup>
</script>

<template>
  <p class="mb-custom-sm mt-custom-lg">
    {{ $t('contact.contact_dexon') }}
  </p>
  <NuxtLink :to="localePath({ path: '/contact-us' })">
    <UIButton theme="outline" class="rounded-full">
      <template #default>
        {{ $t('button.contact') }}
      </template>
    </UIButton>
  </NuxtLink>
</template>
